import type { ReactNode } from 'react';
import React, { useMemo, useState } from 'react';

import { WidgetAnimationContext } from './context';

export const WidgetAnimationProvider = ({
  children,
  animationTime = 3000
}: {
  children: ReactNode;
  animationTime?: number;
}) => {
  const [elementsToAnimateId, setElementsToAnimateId] = useState<Set<string> | null>(null);

  const value = useMemo(
    () => ({
      elementsToAnimateId,
      setElementsToAnimateId,
      animationTime
    }),
    [elementsToAnimateId, animationTime, setElementsToAnimateId]
  );
  return <WidgetAnimationContext value={value}>{children}</WidgetAnimationContext>;
};
